import React from 'react';

const Indoor = () => {
    return (
        <div>
            {/* indoor bath section  */}
            <section className='container '>
                <div className='shadow'>
                    <div className='indoor-bath-bg mt-5 '>
                        <div className='py-5'>
                            {/* <div className="py-5"></div> */}
                            <div className="row ">
                                <div className="col-12 col-md-6 col-lg-4 text-light ">
                                    <div className='p-2'>
                                        <h1 className=' '>Indoors</h1>
                                        <p>Our large domed area offers all-weather enjoyment including swimming in a large pool with Mediterranean Sea theme and luxuriating in baths containing wine, coffee or Japanese sake for a unique and entertaining experience.</p>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="py-5"></div> */}
                        </div>
                    </div>

                    <div className=''>
                        {/* aegean sea ofgods */}
                        <div className="row mt-5  align-items-center">
                            <div className="col-12 col-lg-7 p-4">
                                <img src='https://i.ibb.co/tCLKq9W/Aegean-Sea-of-Gods.jpg' className='img-fluid' alt="" />
                            </div>
                            <div className="col-12 col-lg-5 p-4">
                                <h1 className='pacifico-font'>Aegean Sea of Gods</h1>
                                <p className='mt-3'>Swim and play in our large sea themed pool. An illuminated fountain show with bubbles and music provides entertainment every 30 minutes. Exercise sessions are also periodically held. For details, visit the Events page.</p>
                            </div>

                        </div>
                        {/* wine bath  */}
                        <div className="row mt-5  align-items-center">
                            <div className="col-12 col-lg-5 p-4">
                                <h1 className='pacifico-font'>Wine bath</h1>
                                <p className='mt-3'>Discover the joy of our vividly colorful and richly fragrant hot spring containing wine, a luxury adored by Cleopatra and Queen Mary for its skin rejuvenating qualities. Every day we add more wine at 10am, 1:30pm and 4pm for your viewing pleasure. No drinking, please.</p>

                            </div>
                            <div className="col-12 col-lg-7 p-4">
                                <img src='https://i.ibb.co/3YMmGQ5/Wine-bath.jpg' className='img-fluid' alt="" />
                            </div>
                        </div>
                        {/* Coffee bath    */}
                        <div className="row mt-5  align-items-center">
                            <div className="col-12 col-lg-7 p-4">
                                <img src='https://i.ibb.co/sqTSt6S/Coffee-bath.jpg' className='img-fluid' alt="" />
                            </div>
                            <div className="col-12 col-lg-5 p-4">
                                <h1 className='pacifico-font'>Coffee bath</h1>
                                <p className='mt-3'>The first of its kind in Japan, this hot spring bath contains nel dripped coarse coffee brewed at low temperatures from hot spring water. The healing aroma is said to reduce fatigue and beautify skin. Don’t miss it when we add more coffee at 9:30am, 12:30pm and 3:30pm with support from M.M.C Mitsumoto Coffee Co., Ltd. No drinking, please.</p>

                            </div>
                        </div>

                        {/* Dr. Fish foot bath */}
                        <div className="row mt-5  align-items-center">
                            <div className="col-12 col-lg-5 p-4">
                                <h1 className='pacifico-font'>Dr. Fish foot bath</h1>
                                <p className='mt-3'>
                                    Let tropical fish nibble away rough skin from your feet! It feels so good you may never want to leave. <br />
                                    $50/person for an experience that lasts a few minutes. One time per person. Minimum age is 3. There may be a wait when the facilities are crowded. Usual hours are 10:30am - noon, 2pm - 3:30pm and 4:30pm - 5:30pm, but hours may vary and the bath may close without notice.
                                </p>

                            </div>
                            <div className="col-12 col-lg-7 p-4">
                                <img src='https://i.ibb.co/gWLZtjq/Getty-Images-148469764-1200x630.jpg' className='img-fluid' alt="" />
                            </div>
                        </div>

                        {/* Splish-Splash pool    */}
                        <div className="row mt-5  align-items-center">
                            <div className="col-12 col-lg-7 p-4">
                                <img src='https://i.ibb.co/82LntXs/Splish-Splash-pool.jpg' className='img-fluid' alt="" />
                            </div>
                            <div className="col-12 col-lg-5 p-4">
                                <h1 className='pacifico-font'>Splish-Splash pool</h1>
                                <p className='mt-3'>Young kids love playing in this shallow pool with squirt fountains and our unique BOXAPPY (BOX cat is hAPPY) character (water depth: 30cm).</p>

                            </div>
                        </div>

                        {/* other baths  */}
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-5 text-center">
                            <div className="col">
                                <img src="https://i.ibb.co/q1DYS7t/Green-tea-bath.jpg" className='img-fluid' alt="" />
                                <h4 className='my-3 pacifico-font'>Green tea bath</h4>
                                <p className=''>The vivid green hot spring water with soothing tea fragrance beautifies skin and improves blood circulation. No drinking, please.</p>
                            </div>
                            <div className="col">
                                <img src="https://i.ibb.co/Q6sDTWN/Japanese-sake-bath.jpg" className='img-fluid' alt="" />
                                <h4 className='my-3 pacifico-font'>Japanese sake bath</h4>
                                <p className=''>Genuine Japanese sake drips down from a big barrel, but it’s not for drinking! It fills the air with a comforting aroma and enters the hot spring to warm you deep inside.</p>
                            </div>
                            <div className="col">
                                <img src="https://i.ibb.co/hWxH2yz/Green-terrace.jpg" className='img-fluid' alt="" />
                                <h4 className='my-3 pacifico-font'>Green terrace</h4>
                                <p className=''>This sunny terrace with warm wooden decks features three baths and a Jacuzzi for your bathing pleasure. Check our Events page to see when our next unique bathing experience takes place there.</p>
                            </div>
                            <div className="col">
                                <img src="https://i.ibb.co/bXL0szY/hotstone-1.jpg" className='img-fluid' alt="" />
                                <h4 className='my-3 pacifico-font'>Warmed stone room</h4>
                                <p className=''>Lie down on your tummy and rest in our Warmed stone room, where the comfortably warm stones will heat you deep down.</p>
                            </div>
                            <div className="col">
                                <img src="https://i.ibb.co/bzFwXxq/Finnish-sauna.jpg" className='img-fluid' alt="" />
                                <h4 className='my-3 pacifico-font'>Finnish sauna</h4>
                                <p className=''>For a change of pace, spend some time sweating in our dry wooden sauna with beautiful window view. Hot springs are even more refreshing after this experience.</p>
                            </div>
                            <div className="col">
                                <img src="https://i.ibb.co/WPnpk4M/Aroma-room.jpg" className='img-fluid' alt="" />
                                <h4 className='my-3 pacifico-font'>Aroma room</h4>
                                <p className=''>Refresh body and soul in a room with aromas that change every season.</p>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </div>
    );
};

export default Indoor;